/**
 * useDocumentTitle
 *
 * Aggiorna il titolo del tab browser con il numero di notifiche non lette.
 * "(3) ONET CRM" → "ONET CRM" quando tutte sono lette.
 *
 * Uso: chiamare una volta in App.jsx (dentro il Router).
 */
import { useEffect } from 'react';
import { useNotifications } from '../context/NotificationContext';

const BASE_TITLE = 'ONET CRM';

export function useDocumentTitle() {
    const { unread } = useNotifications();

    useEffect(() => {
        document.title = unread > 0 ? `(${unread > 99 ? '99+' : unread}) ${BASE_TITLE}` : BASE_TITLE;
    }, [unread]);

    // Cleanup al logout: ripristina il titolo base
    useEffect(() => {
        return () => { document.title = BASE_TITLE; };
    }, []);
}
